var _path, _path2, _rect, _rect2, _path3, _g, _rect3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitreSejour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 523,
    height: 333,
    viewBox: "0 0 523 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54956 21.8183C8.54956 14.419 14.5479 8.42065 21.9472 8.42065H500.913C508.312 8.42065 514.311 14.419 514.311 21.8183V311.466C514.311 318.865 508.312 324.864 500.913 324.864H21.9472C14.5479 324.864 8.54956 318.865 8.54956 311.466V21.8183Z",
    fill: "url(#paint0_linear_2025_5709)",
    stroke: "#FFEEE9",
    strokeWidth: 8.10204
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 27H69.5V37.7541H56.6076C55.9755 34.3126 52.9603 31.7049 49.3361 31.7049C45.7118 31.7049 42.6967 34.3126 42.0645 37.7541H28.5V27ZM42.0645 40.4426H28.5V50.5246H69.5V40.4426H56.6076C55.9755 43.8841 52.9603 46.4918 49.3361 46.4918C45.7118 46.4918 42.6967 43.8841 42.0645 40.4426ZM53.52 40.4426C52.9522 42.2115 51.2936 43.4918 49.3361 43.4918C47.3785 43.4918 45.72 42.2115 45.1521 40.4426H53.52ZM53.52 37.7541H45.1521C45.72 35.9852 47.3785 34.7049 49.3361 34.7049C51.2936 34.7049 52.9522 35.9852 53.52 37.7541Z",
    fill: "#A3BBDC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.5,
    y: 27,
    width: 328,
    height: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 27,
    width: 75,
    height: 24,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9472 16.5268H500.913C503.835 16.5268 506.205 18.8959 506.205 21.8183V311.466C506.205 314.389 503.835 316.758 500.913 316.758H21.9472C19.0248 316.758 16.6557 314.389 16.6557 311.466V21.8183C16.6557 18.8959 19.0248 16.5268 21.9472 16.5268ZM21.9472 2.6817C11.3784 2.6817 2.81061 11.2495 2.81061 21.8183V311.466C2.81061 322.035 11.3784 330.603 21.9472 330.603H500.913C511.482 330.603 520.05 322.035 520.05 311.466V21.8183C520.05 11.2494 511.482 2.6817 500.913 2.6817H21.9472Z",
    fill: "white",
    stroke: "#FFEEE9",
    strokeWidth: 3.37585
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 189.838,
    y: 69.5388,
    width: 37.4729,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 247.061,
    y: 69.5388,
    width: 251.102,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 189.838,
    y: 101.883,
    width: 37.4729,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 247.061,
    y: 101.883,
    width: 251.102,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 189.838,
    y: 134.226,
    width: 37.4729,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 247.061,
    y: 134.226,
    width: 251.102,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 189.838,
    y: 166.57,
    width: 37.4729,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 247.061,
    y: 166.57,
    width: 251.102,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 189.838,
    y: 198.914,
    width: 37.4729,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 247.061,
    y: 198.914,
    width: 251.102,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 189.838,
    y: 231.258,
    width: 37.4729,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 247.061,
    y: 231.258,
    width: 251.102,
    height: 14.7266,
    fill: "#5E89C2",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 299,
    width: 501,
    height: 22,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.307 238.956L102.298 238.962C101.824 239.314 101.357 239.66 100.899 240C100.44 239.66 99.9733 239.314 99.4991 238.962L99.4905 238.956C96.2529 236.557 92.6631 233.897 88.8661 230.905C96.535 226.22 104.524 220.551 112.258 213.538L113.321 212.573C120.426 206.23 127.6 198.741 134.031 189.589C145.939 172.645 155.587 149.465 155.42 116.755L155.412 115.218L153.934 114.832C134.892 109.859 112.126 107.849 100.957 107.517L100.899 107.515L100.84 107.517C89.6714 107.849 66.9057 109.859 47.863 114.832L46.3851 115.218L46.3772 116.755C46.2105 149.465 55.8584 172.645 67.7662 189.589C72.8073 196.763 78.3045 202.914 83.8669 208.293C79.801 211.097 75.7325 213.579 71.7374 215.818C50.0779 194.133 28.8881 160.446 32.5373 105.338C55.3992 97.1406 87.3715 94.3588 100.879 94.0005L100.899 94L100.918 94.0005C114.425 94.3588 146.398 97.1406 169.26 105.338C172.065 147.701 160.193 177.369 144.769 198.649C134.001 213.505 121.461 224.329 110.823 232.55C107.802 234.885 104.939 237.006 102.307 238.956Z",
    fill: "#1956A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.625 176.029C75.625 162.766 86.3033 152.014 99.4756 152.014C112.648 152.014 123.326 162.766 123.326 176.029V177.95H75.625V176.029Z",
    fill: "#1956A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.484 135.528C111.484 142.337 106.002 147.856 99.2402 147.856C92.4782 147.856 86.9966 142.337 86.9966 135.528C86.9966 128.72 92.4782 123.2 99.2402 123.2C106.002 123.2 111.484 128.72 111.484 135.528Z",
    fill: "#1956A8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2025_5709",
    x1: 11,
    y1: 142.5,
    x2: 508,
    y2: 142.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320908,
    stopColor: "#ECEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552327,
    stopColor: "#E8EFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805998,
    stopColor: "#ECEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitreSejour);
export default __webpack_public_path__ + "static/media/TitreSejour.16429a209b8c88e2c82950182ff2e63a.svg";
export { ForwardRef as ReactComponent };